import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'card-generator-cmp',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./card-generator.scss'],
  templateUrl: './card-generator.html'
})
export class CardGeneratorComponent {

  _cardInformation: any = null;
  @Input() public set cardInformation(value: any) {
    if (value) {
      this._cardInformation = value;

      if (value.information && value.information.length > 0) {
        this._cardInformation = value
      }
    }
  }

  constructor() {

  }
}